var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMute(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 49,
    height: 53,
    viewBox: "0 0 49 53",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M28.945 34.5225V47.4675C28.945 47.6705 28.655 47.9405 28.245 48.1005C27.667 48.3505 26.964 48.3385 26.636 48.1005L19.507 39.1165L16.593 36.2255C14.886 34.5225 12.605 33.5925 10.195 33.5925H6.54596C6.03396 33.5925 5.60498 33.1745 5.60498 32.6515V19.9985C5.60498 19.4875 6.03396 19.0575 6.54596 19.0575H10.195C10.964 19.0575 11.726 18.9675 12.456 18.7765L8.17499 14.6865H6.54596C3.62396 14.6865 1.245 17.0775 1.245 19.9985V32.6515C1.245 35.5845 3.62396 37.9635 6.54596 37.9635H10.195C11.445 37.9635 12.636 38.4555 13.523 39.3345L16.167 41.9365L23.327 50.9595L23.507 51.1595C24.495 52.1395 25.905 52.6515 27.386 52.6515C28.234 52.6515 29.105 52.4795 29.933 52.1395C32.023 51.2605 33.316 49.4795 33.316 47.4675V38.6945L28.945 34.5225ZM29.933 0.518536C27.655 -0.442464 25.066 -0.0404612 23.507 1.49854L16.167 10.7135L14.273 12.5845L17.445 15.6045L19.335 13.7335L26.636 4.54953C26.964 4.31153 27.667 4.31153 28.245 4.54953C28.655 4.72153 28.945 4.99154 28.945 5.18254V26.5885L33.316 30.7605V5.18254C33.316 3.17854 32.023 1.38954 29.933 0.518536Z",
    fill: "#303634"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M1.91296 4.73753L46.4678 47.2955",
    stroke: "#303634",
    strokeWidth: 3.82582,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMute);
export default __webpack_public_path__ + "static/media/mute.264e57ba6084d0c41b75ed45b5340386.svg";
export { ForwardRef as ReactComponent };